export const environment = {
    production: true,
    prepopulateFormsForDevelopment: false,
    appName: "YuDriv Portal",
    apiPath: "https://ygtsbportalapi.gov.yk.ca",
    debugLevel: 0,
    notificationMessage: { success: 3, error: 0, warning: 0 },
    useGoogleAnalytics: true
};



// WEBPACK FOOTER //
// c:/Projects/YuDRIV/ServicesAPI/YuDriv-ServicesAPI/Enforcement/src/environments/environment.ts